import React from 'react';
import PropTypes from 'prop-types';
import styles from './lcResourcesArticles.module.scss';
import LcResourcesArticleItem from '../lcResourcesArticleItem/lcResourcesArticleItem';

export default function LcResourcesArticles({ title = null, items = null }) {
  return (
    <section className={styles.moreArticle}>
      <div className={styles.title}>{title}</div>
      {items?.map((item, index) => {
        const key = `item-${index}`;
        return (
          <div className={styles.articleContainer} key={key}>
            <LcResourcesArticleItem {...item} />
          </div>
        );
      })}
    </section>
  );
}

LcResourcesArticles.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.shape({
        label: PropTypes.string,
        link: PropTypes.string,
      }),
      publishedDate: PropTypes.string,
      subTitle: PropTypes.shape({
        label: PropTypes.string,
        link: PropTypes.string,
      }),
      description: PropTypes.string,
      timeDuration: PropTypes.string,
      image: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
      }),
    })
  ),
};
